export const formatHour = (hour, minute, dontStripMinutes) => {
  if (window.i18next.language == 'fr') {
    return getFrenchHour(hour, minute, dontStripMinutes);
  } else {
    return getEnglishHour(hour, minute, dontStripMinutes);
  }
}

export const getFrenchHour = (hour, minute, dontStripMinutes) => {
  // remove leading zeros
  if (hour[0] == "0") {
    hour = hour[1];
  }

  if (minute == "00" && !dontStripMinutes) {
    return hour + 'h' ;
  } else {
    return hour + "h" + minute;
  }
}

export const getEnglishHour = (hour, minute, dontStripMinutes) => {
  // remove leading zeros
  if (hour[0] == "0") {
    hour = hour[1];
  }

  if (hour >= 13) {
    if (minute == "00" && !dontStripMinutes) {
      return hour - 12 + " p.m.";
    } else {
      return hour - 12 + ":" + minute + " p.m.";
    }
  } else {
    if (minute == "00" && !dontStripMinutes) {
      return hour + " a.m.";
    } else {
      return hour + ":" + minute + " a.m.";
    }
  }
}
